import { borderRadius, color, Grid, spacing, styled } from '@lessonup/ui-components';
import React from 'react';
import { useEffectivePinComponentSettings } from '../../../../utils/pinTheme/PinThemeContext';

export interface QuizPinAnswersSectionProps {
  pointerEvents?: 'none' | 'auto';
}

export const QuizPinAnswersSection = ({
  pointerEvents,
  children,
}: React.PropsWithChildren<QuizPinAnswersSectionProps>) => {
  // While the QuizPinAnswers section is not refactored into an Answer Area
  const answerAreaSettings = useEffectivePinComponentSettings('ANSWER_AREA', { settings: {} });
  return (
    <StyledAnswersWrapper
      backgroundColor={answerAreaSettings.backgroundColor}
      cols={2}
      gap={spacing.size16}
      pointerEvents={pointerEvents}
    >
      {children}
    </StyledAnswersWrapper>
  );
};

interface StyledAnswersWrapperProps extends QuizPinAnswersSectionProps {
  backgroundColor?: string;
}

const StyledAnswersWrapper = styled(Grid)<StyledAnswersWrapperProps>`
  pointer-events: ${({ pointerEvents }) => pointerEvents || 'auto'};
  position: absolute;
  left: ${spacing.size24};
  right: ${spacing.size24};
  bottom: ${spacing.size24};
  padding: ${spacing.size16};
  background-color: ${({ backgroundColor }) => backgroundColor || color.neutral.surface.background};
  border-radius: ${borderRadius.rounded24};
`;
